import { HideOptions, ShowOptions, SplashScreenDef } from "./SplashScreenDef";
import { CapacitorAccess } from "../capacitor";

export class SplashAccessor implements SplashScreenDef {
    private static _instance: SplashAccessor;
    private readonly _plugin: any;

    private constructor() {
        this._plugin = CapacitorAccess.plugins?.SplashScreen;
    }

    public static get instance(): SplashAccessor {
        this._instance ??= new SplashAccessor();
        return this._instance;
    }

    hide(options?: HideOptions | undefined): Promise<void> {
        return this._plugin?.hide(options);
    }

    show(options?: ShowOptions | undefined): Promise<void> {
        return this._plugin?.show(options);
    }
}
